import React from "react";

export interface ModelConfig {
  name: string;
  ecr_repo_name: string;
  version: string;
  concurrency_limit: string;
  imageUrl: string;
  modelDataUrl: string;
  sageMakerEndpointVersion: string;
  instanceType: string;
  imageListSize: number;
  initialInstanceCount: number;
  max_tokens: string;
  temperature: string;
  env: {
    MODEL_FILE_LIST: string;
    HUGGINGFACE_HUB_CACHE: string;
    MAX_MODEL_LEN: string;
    GPU_MEMORY_UTILIZATION: string;
    TRANSFORMERS_CACHE: string;
    MAX_NUM_SEQS: string;
    s3url: string;
    AWS_DEFAULT_REGION: string;
    VLLM_WORKER_MULTIPROC_METHOD: string;
  };
}
export interface Config {
  aws_project_region: string;
  aws_region: string;
  aws_api_base_url: string;
  aws_oidc_provider: string;
  aws_oidc_client_id: string;
  aws_oidc_customer_domain: string;
  aws_cloudfront_url: string;
  aws_oidc_redirect_url: string;
  aws_oidc_logout_url: string;
  enable_citation_viewer_auth?: boolean;
  enable_voice_chat?: boolean;
  dev_mode?: boolean;
  version?: string;
}
const ConfigContext = React.createContext<Config | null>(null);
export default ConfigContext;
